<div class="modal right" id="stockDetail" tabindex="-1" role="dialog" aria-labelledby="stockDetailLabel">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content" id="print-content">
			<div class="modal-header bg-light hide-print">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
				<h4 class="modal-title fs18" id="stockDetailLabel">Stok No : {{ data.stock.id }}</h4>			
			</div>
	
			<div class="modal-body with-tab">
	
				<div class="loading" ng-if="loadingWork">
					<div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
				</div>
						
				<ul class="nav nav-tabs nav-justified" id="tabContent">
					<li class="active">
						<a target="_self" href="#stockDetails" data-toggle="tab">Stok Detayları</a>
					</li>
					<li>
						<a target="_self" href="#movements" data-toggle="tab">Stok Hareketleri</a>
					</li>
				</ul>

				<div class="tab-content">
					<div class="tab-pane active" id="stockDetails">
						<div class="row mt15">
							<div class="col-md-12">
								<div class="panel mb10">
									<div class="panel-body mt10">
										<div class="col-md-6">
											<p>
												<strong>Stok Adı : </strong>
												<span>{{ data.stock.name }}</span>
											</p>
											<p>
												<strong>Seri No : </strong>
												<span>{{ data.stock.serial_number }}</span>
											</p>
											<p>
												<strong>Miktar : </strong>
												<span>{{ data.stock.piece }}</span>
											</p>
											<p>
												<strong>Birim : </strong>
												<span>{{ data.stock.unit }}</span>
											</p>
										</div>
										<div class="col-md-6">
											<p>
												<strong>Bağlı Olduğu Depo : </strong>
												<a href="#" ng-click="getStockStoreDetail(data.stock.store.id)" ng-if="data.stock.store">{{ data.stock.store.name }}</a>
												<span ng-if="!data.stock.store">Yok</span>
											</p>
											<p >
												<strong>Bağlı Olduğu Personel : </strong>
												<a href="#" ng-click="getWorkerDetails(data.stock.worker.id)" ng-if="data.stock.worker">{{ data.stock.worker.full_name }}</a>
												<span ng-if="!data.stock.worker">Yok</span>
											</p>
											<p>
												<strong>Kayıt Tarihi : </strong> 
												<span>{{ data.stock.created_at | amUtc | amDateFormat:'MM/DD/YYYY, HH:mm' }}</span>
											</p>
											<p>
												<strong>Kayıt Sahibi : </strong> 
												<span>{{ data.stock.user.full_name }}</span>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="tab-pane" id="movements">
						<div class="row mt15">
							<div class="col-md-12">
								<div class="panel mb10">
									<table class="table table-hover tc-checkbox-1 fs13" ng-if="data.stock.movements.length > 0">
										<thead>
											<tr class="bg-light">
												<th>
													<a href="#" ng-click="sortType = 'id'; sortReverse = !sortReverse">
													Hareket NO
													<span ng-show="sortType == 'id' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'id' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'worker.full_name'; sortReverse = !sortReverse">
													Personel Bilgileri
													<span ng-show="sortType == 'worker.full_name' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'worker.full_name' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'order_id'; sortReverse = !sortReverse">
													Ait Old.Kargo
													<span ng-show="sortType == 'order_id' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'order_id' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'type'; sortReverse = !sortReverse">
													Hareket Durumu
													<span ng-show="sortType == 'type' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'type' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'type'; sortReverse = !sortReverse">
													Yapılan İşlem
													<span ng-show="sortType == 'type' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'type' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'piece'; sortReverse = !sortReverse">
													Adet
													<span ng-show="sortType == 'piece' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'piece' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
												<th>
													<a href="#" ng-click="sortType = 'created_at'; sortReverse = !sortReverse">
													Tarih
													<span ng-show="sortType == 'created_at' && !sortReverse" class="fa fa-caret-down"></span>
													<span ng-show="sortType == 'created_at' && sortReverse" class="fa fa-caret-up"></span>
													</a>
												</th>
											</tr>
										</thead>
										<tbody>
										<tr ng-repeat="item in data.stock.movements | orderBy:sortType:sortReverse">
											<td class="clickable-row text-left">#{{item.id}}</td>
											<td class="clickable-row">{{ item.worker.full_name }} </td>
											<td class="clickable-row"> <a href="#" ng-click="getOrderDetails(item.order_id)">#{{ item.order_id }}</a> </td>
											<td class="clickable-row">{{ item.type == 1 ? 'Giriş' : 'Çıkış' }}</td>
											<td class="clickable-row">{{ item.part_type }}</td>
											<td class="clickable-row">{{ item.piece }}</td>
											<td class="clickable-row">{{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}</td>
										</tr>
										</tbody>
									</table>

									<div ng-if="data.stock.movements.length == 0">
										Bu Stokye ait bir iş henüz oluşturulmamıştır.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<div class="modal-footer bg-light hide-print">
				<button type="button" class="btn btn-default" data-dismiss="modal">Kapat</button>
				<a href="stok/urun/{{ data.stock.id }}" class="btn btn-warning">Düzenle</a>
			</div>
		</div>
	</div>
</div>
<style>
	html, body {
	height: 100%;
	}
</style>